import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryManufacturereListResponse } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setManufacturerList } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useInventoryManufacturereListActiveAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(async () => {
    dispatch(
      setLoading({
        key: "isManufacturereListLoadingInProgress",
        status: true,
      }),
    );

    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(INVENTORY_MODULE?.MANUFACTURER_LIST_ACTIVE?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IInventoryManufacturereListResponse>) => {
          if (res.data.status === true) {
            dispatch(setManufacturerList({ data: res.data.data }));
            dispatch(
              setLoading({
                key: "isManufacturereListLoadingInProgress",
                status: false,
              }),
            );
          } else {
            dispatch(setManufacturerList({ data: [] }));
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          dispatch(
            setLoading({
              key: "isManufacturereListLoadingInProgress",
              status: false,
            }),
          );

          captureError(e)
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
